import SearchSuggestions from "./../components/search-suggestions/presenter/search-suggestions.js";

const searchInput = document.querySelector(`[name="query"]`);

if (searchInput) {
  const searchSuggestionsComponent = new SearchSuggestions(searchInput);
  searchSuggestionsComponent.init();
}
